import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";
/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

//modifier un Paramètre EDT (jours ouvrable)
export const updateSetting = async (payload, id_academicYear, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/settingedt/${id_academicYear}`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// récupérer les paramètres EDT d'une année
export const getSettingById = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/settingedt/${id_academicYear}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

//recuperer les Paramètre EDT a travers son id
export const getSettingByYear = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/settingedt/year/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// ---------------------------------SESSIONS------------------------------------------------------

// sauvegarder les sessions d'une année
export const saveSessionByYear = async (payload, id_academicYear, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/sessions/create/${id_academicYear}`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// récupérer les séances d'une année
export const getSessionsByYear = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/sessions/year/${id_academicYear}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// modifier une séance
// export const updateSession= async (paylodx   )

// ---------------------------------PAUSES------------------------------------------------------

// sauvegarder les pauses d'une année
export const saveBreaksByYear = async (payload, id_academicYear, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/break/create/${id_academicYear}`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};
// récupérer les pauses d'une année
export const getBreaksByYear = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/break/year/${id_academicYear}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};
